import React, {useEffect, useState} from "react";
//import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
//import { mockDataContacts } from "../../data/mockData";
import Header from "../../components/Header.jsx";
//import { useTheme } from "@mui/material";

import { Box, IconButton, useTheme } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";

const TableXDataGrid = (props) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  const columns = [];

  ///
  const [tableXDataGridColums, setTableXDataGridColums]=useState(props.tableColumns);
  const [tableDataOG, setTableDataOG]= useState([]);
  const [dataFromSrc, setDataFromSrc] = useState([]);
  const [select, setselect] = useState('');
  const [dataUrl, setdataUrl]=useState(props.url)
  let   [data, setData]= useState([]);

  const [searchValue, setSearchValue]=useState('');
  const [searchValueT, setSearchValueT]=useState('');
  const findSearchValue=(newSearchValue)=>{
        setSearchValue(newSearchValue);
        console.log("sv=" + searchValue);
  }
  
  function loadData(dataLoaded){
    console.log("datal=" + dataLoaded);
    setDataFromSrc(dataLoaded);
    setTableDataOG(dataLoaded);
  };
  

  const [loading, setLoading] = useState(false)
      useEffect(() => {
        setLoading(true)
        fetch(dataUrl)
          .then(response => response.json())
          .then(json => loadData(json))
          .finally(() => {
            setLoading(true); 
          })
      }, [])
    

    useEffect(() => {
    let searchtxt=searchValueT.toLowerCase();
    console.log("searchtxt=" + searchtxt);
    console.log("searchtxtL=" + searchtxt.length);
    data = tableDataOG.filter(tableDataOG => tableDataOG.first_name.toLowerCase().includes(searchValueT.toLowerCase()) ||  tableDataOG.middle_name.toLowerCase().includes(searchValueT.toLowerCase()) ||  tableDataOG.last_name.toLowerCase().includes(searchValueT.toLowerCase()));
    setDataFromSrc(data);
    console.log("newdata=" + data)
     // }
    
    }, [searchValueT])
    
  ///
  const handleOnChangeSearchText=(e)=>{
     
    console.log("searchValue=" + searchValueT);
       setSearchValueT(e.target.value);
       console.log("searchValueT=" + searchValueT);
    }
  
  ///

  return (
    <Box m="20px">
      <Header
        title="CONTACTS"
        subtitle="List of Contacts for Future Reference"
      />
      <Box
        m="40px 0 0 0"
        height="155vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="3px"
      >
        <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" onChange={handleOnChangeSearchText} />
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton>
      </Box>

        <DataGrid
          rows={dataFromSrc}
          columns={tableXDataGridColums}
          components={{ Toolbar: GridToolbar }}
          rowHeight={props.rowHeightP}
          
        />
      </Box>
    </Box>
  );
};

export default TableXDataGrid;
